const TEMPLATE = `
<div class="fc-flexbox-event-details-content">
    <div class="fc-flexbox-details-content">
        <div class="event-full-details">
            <div class="event-featured-image" id="featured-image-\${id}" style="display: none;">
                <img src="" alt="\${title}" class="event-thumbnail img-fluid mb-3">
            </div>
            <div class="event-description" style="display: \${description ? 'block' : 'none'}">
                <h6>Description</h6>
                <p>\${description}</p>                
                \${inscription_btn_html}
            </div>
            \${map_html}
            <div class="event-partenaires" style="display: \${partenaires && partenaires.length > 0 ? 'block' : 'none'}">
                <div class="partenaires-cards-container">
                    \${partenaires_html}
                </div>
            </div>
            \${inscription_btn_html}
        </div>
    </div>
</div>`;

// Fonction pour remplir le template avec des données
function fillTemplate(data) {
    // Générer le HTML des partenaires si disponibles
    if (data.partenaires && data.partenaires.length > 0) {
        data.partenaires_html = generatePartenairesHTML(data.partenaires);
    } else {
        data.partenaires_html = '';
    }

    // Vérifier et nettoyer l'URL de l'image à la une si elle existe
    if (data.featured_image) {
        // S'assurer que l'URL est bien une chaîne et non un objet
        if (typeof data.featured_image !== 'string') {
            data.featured_image = String(data.featured_image);
        }
    }
    
    // Convertir places_disponibles en nombre et déterminer si on affiche les boutons d'inscription
    const placesDisponibles = parseInt(data.places_disponibles || '0', 10);
    data.show_inscription_btn = placesDisponibles > 0;

    data.inscription_btn_html = data.show_inscription_btn ? 
        (data.disable_native_inscription && data.external_inscription_url ? 
            `<div class="event-actions">
                <a href="${data.external_inscription_url}" class="go-booking-inscription-btn" target="_blank">
                    ${data.external_inscription_label || 'S\'inscrire à l\'animation'}
                </a>
            </div>` :
            `<div class="event-actions">
                <button class="go-booking-inscription-btn" data-toggle="modal" data-event-id="${data.id}">
                    S'inscrire à l'animation
                </button>
            </div>`) : '';

    const lat = parseFloat(data.latitude);
    const lng = parseFloat(data.longitude);
    const hasMap = (
        data.latitude !== null &&
        data.latitude !== undefined &&
        data.latitude !== '' &&
        data.longitude !== null &&
        data.longitude !== undefined &&
        data.longitude !== '' &&
        !isNaN(lat) &&
        !isNaN(lng) &&
        !(lat === 0 && lng === 0)
    );
    
    data.map_html = hasMap ? `
        <div class="fc-event-map-container">
            <div id="map-${data.id}" class="animation-map"></div>
        </div>
    ` : '';

    return TEMPLATE.replace(/\${(\w+)}/g, (match, key) => {
        if (key === 'categories' && data[key]) {
            return data[key].map(cat => {
                // Gestion du cas où cat est un objet {name, color}
                if (typeof cat === 'object' && cat.name && cat.color) {
                    return `<span class="event-category-tag" style="background-color: ${cat.color};">${cat.name}</span>`;
                }
                // Cas simple où cat est une chaîne
                return '<span class="event-category-tag">' + cat + '</span>';
            }).join('');
        }
        
        // Si la clé est featured_image, faire un traitement spécial
        if (key === 'featured_image') {
            return data[key] !== undefined ? data[key] : '';
        }
        
        return data[key] !== undefined ? data[key] : match;
    });
}

/**
 * Génère le HTML pour afficher les cartes des partenaires
 * @param {Array} partenaires Liste des partenaires
 * @returns {string} HTML des cartes partenaires
 */
function generatePartenairesHTML(partenaires) {
    if (!partenaires) {
        return '';
    }
    
    // Vérifier et normaliser le format des partenaires
    let partenairesArray = [];
    
    if (Array.isArray(partenaires)) {
        // Déjà un tableau, on le copie simplement
        partenairesArray = [...partenaires];
    } else if (typeof partenaires === 'object') {
        // Si c'est un objet mais pas un tableau, on le convertit
        partenairesArray = Object.values(partenaires);
    } else {
        return '';
    }
    
    // Vérifier si le tableau est vide après normalisation
    if (partenairesArray.length === 0) {
        return '';
    }
    
    let html = '<h6>Partenaires de l\'activité</h6><div class="row row-cols-1 row-cols-md-2 g-4">';
    
    // Compteur pour tracer les partenaires traités
    let partenaireCount = 0;
    
    // Parcourir chaque partenaire et générer son HTML
    partenairesArray.forEach((partenaire, index) => {
        partenaireCount++;
        
        // S'assurer que partenaire est un objet
        if (typeof partenaire !== 'object' || partenaire === null) {
            return; // Continuer avec le prochain partenaire
        }
        
        let urlsHtml = '';
        
        // Normaliser les URLs
        let urls = [];
        
        if (partenaire.urls) {
            if (Array.isArray(partenaire.urls)) {
                urls = partenaire.urls;
            } else if (typeof partenaire.urls === 'object') {
                urls = Object.values(partenaire.urls);
            } else if (typeof partenaire.urls === 'string') {
                // Cas d'une URL unique sous forme de chaîne
                urls = [{ url: partenaire.urls, label: 'Lien' }];
            }
        } else if (partenaire.url) {
            // Compatibilité avec l'ancien format
            urls = [{ url: partenaire.url, label: partenaire.label || 'Lien' }];
        }
        
        if (urls.length > 0) {
            urlsHtml = '<ul class="list-group list-group-flush">';
            
            // Ensemble pour suivre les URLs déjà ajoutées (pour éviter les doublons)
            const addedUrls = new Set();
            
            urls.forEach((urlItem, urlIndex) => {
                let url = '';
                let label = 'Lien';
                
                // Extraire l'URL et le label selon le format
                if (typeof urlItem === 'object' && urlItem !== null) {
                    url = urlItem.url || '';
                    label = urlItem.label || 'Lien';
                } else if (typeof urlItem === 'string') {
                    url = urlItem;
                }
                
                // Vérifier que l'URL est valide
                if (!url) {
                    return; // Passer à l'URL suivante
                }
                
                // Créer une clé unique pour cette URL
                const urlKey = `${url}-${label}`;
                
                // Vérifier si cette URL a déjà été ajoutée
                if (!addedUrls.has(urlKey)) {
                    // Ajouter l'URL à l'ensemble des URLs traitées
                    addedUrls.add(urlKey);
                    
                    urlsHtml += `
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <span>${label}</span>
                            <a href="${url}" class="btn btn-sm btn-outline-primary" target="_blank">
                                <i class="bi bi-box-arrow-up-right me-1"></i>Visiter
                            </a>
                        </li>
                    `;
                }
            });
            
            urlsHtml += '</ul>';
        } else {
            // Ajouter un message si aucune URL n'est disponible
            urlsHtml = `
                <div class="card-footer text-muted">
                    <small>Aucun lien disponible</small>
                </div>
            `;
        }
        
        // Ajouter la carte du partenaire
        html += `
            <div class="col">
                <div class="card h-100 shadow-sm">
                    <div class="card-body">
                        <h5 class="card-title">
                            <i class="bi bi-building me-2"></i>${partenaire.nom || 'Partenaire'}
                        </h5>
                    </div>
                    ${urlsHtml}
                </div>
            </div>
        `;
    });
    
    html += '</div>';
    
    return html;
}

/**
 * Initialise la carte pour afficher toutes les sessions d'une animation
 * @param {string} animationId ID de l'animation
 * @param {string} mapContainerId ID du conteneur de carte
 */
async function initAnimationSessionsMap(animationId, mapContainerId) {
    try {
        const mapContainer = document.getElementById(mapContainerId);
        if (!mapContainer) {
            return null;
        }
        
        // Récupérer les sessions de l'animation
        const sessions = await fetchAnimationSessions(animationId);
        
        // Créer un tableau pour stocker les localisations valides
        const validLocations = [];
        
        // Parcourir les sessions pour extraire les coordonnées
        if (sessions && sessions.length > 0) {
            sessions.forEach((session, index) => {
                if (session.latitude && session.longitude) {
                    validLocations.push({
                        lat: parseFloat(session.latitude),
                        lng: parseFloat(session.longitude),
                        title: session.animation_titre || 'Animation',
                        date: session.formatted_date || session.date,
                        horaire: session.horaire || `${session.heure_debut} - ${session.heure_fin}`,
                        places: session.places_disponibles,
                        lieu_depart: session.lieu_depart,
                        sessionId: session.id,
                        index: index + 1
                    });
                }
            });
        }
        
        // Si aucune localisation valide trouvée, masquer la carte
        if (validLocations.length === 0) {
            mapContainer.style.display = 'none';
            return null;
        }
        
        // Initialiser la carte
        const map = L.map(mapContainerId);
        
        // Ajouter la couche de tuiles OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 19
        }).addTo(map);
        
        // Créer les limites pour centrer la carte
        const bounds = L.latLngBounds();
        
        // Vérifier si la bibliothèque de clusterisation est disponible
        let markerClusterGroup = null;
        const useClusterization = typeof L.markerClusterGroup !== 'undefined';
        
        if (useClusterization) {
            // Créer un groupe de clusters pour les marqueurs
            markerClusterGroup = L.markerClusterGroup({
                maxClusterRadius: 30,
                spiderfyOnMaxZoom: true,
                showCoverageOnHover: true,
                zoomToBoundsOnClick: true,
                animate: true,
                animateAddingMarkers: true,
                disableClusteringAtZoom: 19,
                chunkedLoading: true,
                iconCreateFunction: function(cluster) {
                    const count = cluster.getChildCount();
                    let size = 'small';
                    let additionalClass = '';
                    
                    if (count > 50) {
                        size = 'large';
                        additionalClass = 'cluster-large';
                    } else if (count > 10) {
                        size = 'medium';
                        additionalClass = 'cluster-medium';
                    }
                    
                    return L.divIcon({
                        html: '<div class="cluster-icon ' + additionalClass + '"><span>' + count + '</span></div>',
                        className: 'marker-cluster marker-cluster-' + size,
                        iconSize: L.point(40, 40)
                    });
                }
            });
            map.addLayer(markerClusterGroup);
        }
        
        // Ajouter un marqueur pour chaque localisation
        validLocations.forEach(location => {
            // Couleur du marqueur en fonction des places disponibles
            let markerColor = '#4CAF50'; // Vert par défaut
            
            if (location.places <= 0) {
                markerColor = '#9E9E9E'; // Gris si complet
            } else if (location.places <= 3) {
                markerColor = '#FF9800'; // Orange si peu de places
            }
            
            // Taille du marqueur
            let iconSize = [28, 28];
            let iconAnchor = [14, 14]; // Point d'ancrage au centre exact de l'icône
            
            // Créer une icône personnalisée
            let iconHtml;
            if (validLocations.length > 1 && !location.isMain) {
                // Marqueur numéroté pour les sessions multiples
                iconHtml = `<div style="background-color:${markerColor};width:${iconSize[0]}px;height:${iconSize[1]}px;border-radius:50%;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;color:white;font-weight:bold;font-size:14px;">${location.index || ''}</div>`;
            } else {
                // Marqueur simple pour l'animation principale
                iconHtml = `<div style="background-color:${markerColor};width:${iconSize[0]}px;height:${iconSize[1]}px;border-radius:50%;border:2px solid white;box-shadow:0 0 4px rgba(0,0,0,0.5);"></div>`;
            }
            
            const customIcon = L.divIcon({
                className: 'custom-animation-marker',
                html: iconHtml,
                iconSize: iconSize,
                iconAnchor: iconAnchor,
                popupAnchor: [0, -iconSize[1]/2] // Positionner le popup juste au-dessus du marqueur
            });
            
            // Créer le marqueur
            const marker = L.marker([location.lat, location.lng], {
                icon: customIcon
            });
            
            // Créer le contenu du popup
            let popupContent = `
                <div class="animation-popup" style="min-width:250px;max-width:300px;">
                    <h4 style="color:${markerColor};margin-bottom:12px;border-bottom:2px solid ${markerColor};padding-bottom:6px;font-size:1.1rem;display:flex;align-items:center;justify-content:space-between;">
                        <span>${location.title}</span>
                    </h4>
                    <div style="display:grid;grid-template-columns:28px 1fr;gap:8px;margin-bottom:15px;margin-top:15px;font-size:0.95rem;">
                        <div style="display:flex;align-items:center;justify-content:center;"><i class="bi bi-calendar-event" style="font-size:1.1rem;color:${markerColor};"></i></div>
                        <div style="font-weight:500;">${location.date}</div>
                        
                        <div style="display:flex;align-items:center;justify-content:center;"><i class="bi bi-clock" style="font-size:1.1rem;color:${markerColor};"></i></div>
                        <div style="font-weight:500;">${location.horaire}</div>
                        
                        <div style="display:flex;align-items:center;justify-content:center;"><i class="bi bi-geo-alt" style="font-size:1.1rem;color:${markerColor};"></i></div>
                        <div style="font-weight:500;">${location.lieu_depart ? location.lieu_depart : 'Non défini'}</div>
                    </div>
                </div>
            `;
            
            // Ajouter le popup au marqueur
            marker.bindPopup(popupContent);
            
            // Ajouter au bounds pour centrer la carte
            bounds.extend([location.lat, location.lng]);
            
            // Ajouter le marqueur au groupe de clusters ou directement à la carte
            if (useClusterization && markerClusterGroup) {
                markerClusterGroup.addLayer(marker);
            } else {
                marker.addTo(map);
            }
        });
        
        // Ajuster la vue pour montrer tous les marqueurs
        if (validLocations.length > 1) {
            map.fitBounds(bounds, { padding: [30, 30] });
        } else {
            map.setView([validLocations[0].lat, validLocations[0].lng], 15);
        }
        
        // Forcer une mise à jour de la carte et des clusters
        setTimeout(() => {
            map.invalidateSize();
            
            // Si on utilise la clusterisation, forcer un rafraîchissement
            if (useClusterization && markerClusterGroup && markerClusterGroup._refreshClusters) {
                markerClusterGroup._refreshClusters();
            }
            
            // Forcer un zoom avant/arrière pour rafraîchir les clusters
            if (validLocations.length > 1) {
                const currentZoom = map.getZoom();
                map.setZoom(currentZoom - 1);
                setTimeout(() => map.setZoom(currentZoom), 300);
            }
        }, 500);
        
        return map;
    } catch (error) {
        document.getElementById(mapContainerId).style.display = 'none';
        return null;
    }
}

/**
 * Fonction pour attendre que Leaflet soit chargé
 */
function waitForLeaflet(timeout = 5000) {
    return new Promise((resolve, reject) => {
        if (typeof L !== 'undefined') {
            resolve();
            return;
        }
        
        const startTime = Date.now();
        
        const checkInterval = setInterval(() => {
            if (typeof L !== 'undefined') {
                clearInterval(checkInterval);
                resolve();
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkInterval);
                reject(new Error('Timeout: Leaflet n\'a pas été chargé dans le délai imparti'));
            }
        }, 100);
    });
}

/**
 * Récupère les sessions d'une animation via AJAX
 */
async function fetchAnimationSessions(animationId) {
    try {
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'gobooking_get_sessions',
                nonce: goBookingData.nonce,
                animation_id: animationId
            })
        });

        const result = await response.json();
        
        if (result.success && result.data && result.data.sessions) {
            return result.data.sessions;
        }
        
        return [];
    } catch (error) {
        return [];
    }
}

/**
 * Récupère les partenaires d'une animation via AJAX
 */
async function fetchAnimationPartenaires(animationId) {
    try {
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'gobooking_get_partenaires',
                nonce: goBookingData.nonce,
                animation_id: animationId
            })
        });

        const result = await response.json();
        
        if (result.success && result.data && result.data.partenaires) {
            return result.data.partenaires;
        }
        
        return [];
    } catch (error) {
        return [];
    }
}

/**
 * Récupère les données d'une animation via AJAX
 */
async function fetchAnimationData(animationId) {
    try {
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'gobooking_get_animation_details',
                nonce: goBookingData.nonce,
                animation_id: animationId,
                include_featured_image: true  // Demande explicite de l'image à la une
            })
        });

        const result = await response.json();
        
        if (result.success && result.data) {
            // Vérifier et traiter l'image à la une si présente
            if (result.data.featured_image) {
            } else {
            }
            
            // Récupérer les partenaires et les ajouter aux données
            try {
                const partenaires = await fetchAnimationPartenaires(animationId);
                if (partenaires && partenaires.length > 0) {
                    result.data.partenaires = partenaires;
                } else {
                }
            } catch (error) {
            }
            
            return result.data;
        }
        
        return null;
    } catch (error) {
        return null;
    }
}

/**
 * Initialise l'image à la une de l'animation
 * @param {HTMLElement} container Élément conteneur des détails de l'animation
 * @param {Object} data Données de l'animation
 */
function initFeaturedImage(container, data) {
    if (!container || !data) return;
    
    const imageContainer = container.querySelector(`#featured-image-${data.id}`);
    if (!imageContainer) {
        return;
    }
    
    const imageElement = imageContainer.querySelector('img');
    if (!imageElement) {
        return;
    }
    
    // Si une image à la une est disponible, l'afficher
    if (data.featured_image) {
        imageElement.src = data.featured_image;
        imageContainer.style.display = 'block';
    } else {
        imageContainer.style.display = 'none';
    }
}

/**
 * Initialiser la carte des sessions lorsque le template est chargé
 */
document.addEventListener('DOMContentLoaded', function() {
    const detailsContainer = document.querySelector('.fc-flexbox-event-details-content');
    if (detailsContainer) {
        const eventId = detailsContainer.querySelector('.go-booking-inscription-btn')?.dataset.eventId;
        
        // Tester si l'image à la une est correctement affichée
        const featuredImageElement = detailsContainer.querySelector('.event-featured-image img');
        if (featuredImageElement) {
            if (!featuredImageElement.src || featuredImageElement.src === 'about:blank' || featuredImageElement.src.includes('${featured_image}')) {
                // Récupérer les données de l'animation et initialiser l'image
                if (eventId) {
                    fetchAnimationData(eventId).then(data => {
                        if (data) {
                            initFeaturedImage(detailsContainer, data);
                        }
                    });
                }
            }
        }
        
        const mapContainer = document.getElementById(`map-${eventId}`);
        
        if (eventId && mapContainer) {
            initAnimationSessionsMap(eventId, `map-${eventId}`);
            
            // Test direct de l'appel AJAX pour les partenaires avec débogage complet
            fetch(goBookingData.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'gobooking_get_partenaires',
                    nonce: goBookingData.nonce,
                    animation_id: eventId
                })
            })
            .then(response => {
                return response.json();
            })
            .then(result => {
                if (result.success && result.data && result.data.partenaires) {
                    const partenaires = result.data.partenaires;
                    
                    // Inspecter chaque partenaire individuellement
                    partenaires.forEach((partenaire, index) => {
                    });
                    
                    // Force l'affichage des partenaires avec le nouveau HTML
                    const partenairesHtml = generatePartenairesHTML(partenaires);
                    
                    const partenairesContainer = detailsContainer.querySelector('.partenaires-cards-container');
                    if (partenairesContainer) {
                        partenairesContainer.innerHTML = partenairesHtml;
                        const parentElement = detailsContainer.querySelector('.event-partenaires');
                        if (parentElement) {
                            parentElement.style.display = 'block';
                            
                            // Vérifier après l'insertion que tous les partenaires sont bien présents dans le DOM
                            const cardsInDOM = parentElement.querySelectorAll('.card');
                            
                            if (cardsInDOM.length !== partenaires.length) {
                                setTimeout(() => {
                                    const updatedCards = parentElement.querySelectorAll('.card');
                                    
                                    // Forcer un réaffichage si nécessaire
                                    if (updatedCards.length !== partenaires.length) {
                                        partenairesContainer.innerHTML = '';
                                        setTimeout(() => {
                                            partenairesContainer.innerHTML = generatePartenairesHTML(partenaires);
                                        }, 100);
                                    }
                                }, 500);
                            }
                        }
                    }
                }
            })
            .catch(error => {
            });
        }
    }
    
    // Délégation d'événements pour les popups qui pourraient être ajoutés dynamiquement
    document.body.addEventListener('click', function(event) {
        if (event.target.classList.contains('go-booking-inscription-btn')) {
            const eventId = event.target.dataset.eventId;
            // Action d'inscription
        }
    });
});

// Exposer la fonction initAnimationSessionsMap pour qu'elle soit utilisable par d'autres scripts
window.initAnimationSessionsMap = initAnimationSessionsMap;

export { TEMPLATE, fillTemplate, initAnimationSessionsMap, fetchAnimationPartenaires }; 